import * as React from 'react'

import { Box, Icon, Tag, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

interface Props {
  authorName?: string
}

const Promotion = ({ authorName }: Props) => {
  if (!authorName) return null

  return (
    <Tag type="malibu" inline>
      <Box gap="s4" flexDirection="row" alignItems="center">
        <Icon.Medium icon="check" color="malibu1000" />
        <Text.Normal capitalize weight="medium" size="200" color="grey1000">
          {i18n.t('contract_versions.header.tags.promoted_by', {
            authorName: authorName,
          })}
        </Text.Normal>
      </Box>
    </Tag>
  )
}

export default observer(Promotion)
